var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#ee3994",
    d: "M 40.5,3.5 C 112.834,3.33334 185.167,3.5 257.5,4C 278.729,7.56652 291.896,19.7332 297,40.5C 297.667,101.833 297.667,163.167 297,224.5C 292.21,246.957 278.376,259.124 255.5,261C 186.833,261.333 118.167,261.667 49.5,262C 37.1289,273.373 24.4622,284.373 11.5,295C 7.82007,296.027 4.6534,295.194 2,292.5C 1.33333,207.833 1.33333,123.167 2,38.5C 7.57318,18.6615 20.4065,6.99484 40.5,3.5 Z M 43.5,17.5 C 114.167,17.3333 184.834,17.5 255.5,18C 269.809,20.9769 278.976,29.4769 283,43.5C 283.667,102.833 283.667,162.167 283,221.5C 280.621,232.76 274.121,240.594 263.5,245C 260.247,246.036 256.914,246.703 253.5,247C 183.833,247.333 114.167,247.667 44.5,248C 34.4106,255.418 24.9106,263.585 16,272.5C 15.3333,195.5 15.3333,118.5 16,41.5C 18.9414,33.5633 23.7748,27.0633 30.5,22C 34.8456,20.164 39.179,18.664 43.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.918
    },
    fill: "#ee3994",
    d: "M 63.5,74.5 C 120.834,74.3333 178.168,74.5 235.5,75C 241.016,80.1076 240.683,84.7743 234.5,89C 177.833,89.6667 121.167,89.6667 64.5,89C 58.281,84.5327 57.9476,79.6994 63.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#ed3994",
    d: "M 61.5,134.5 C 119.168,134.333 176.834,134.5 234.5,135C 237.349,137.559 238.183,140.726 237,144.5C 236.021,146.32 234.521,147.487 232.5,148C 176.167,148.667 119.833,148.667 63.5,148C 57.6611,144.295 56.9945,139.795 61.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#ed3994",
    d: "M 61.5,193.5 C 118.501,193.333 175.501,193.5 232.5,194C 237.276,197.91 237.609,202.244 233.5,207C 175.833,207.667 118.167,207.667 60.5,207C 55.197,202.098 55.5303,197.598 61.5,193.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPink);
export default __webpack_public_path__ + "static/media/Chat_pink.202498c1c82ad4d50e9a4638182bda2a.svg";
export { ForwardRef as ReactComponent };